import script from "./Logout.vue?vue&type=script&setup=true&lang=ts"
export * from "./Logout.vue?vue&type=script&setup=true&lang=ts"

import "./Logout.vue?vue&type=style&index=0&id=6a69a831&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a69a831"]])

export default __exports__